import React, { useContext } from "react";
import { Redirect } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";

const ProtectedRoute = ({ 
  children, 
  requiredRoles = [], 
  fallbackPath = "/tickets" 
}) => {
  const { user } = useContext(AuthContext);

  // Debug: Log para verificar dados do usuário no ProtectedRoute
  // console.log('ProtectedRoute - Dados do usuário:', {
  //   user,
  //   requiredRoles,
  //   userRoles: user?.roles,
  //   profile: user?.profile,
  //   super: user?.super
  // });

  // Se não há usuário logado, redireciona
  if (!user) {
    // console.log('Usuário não logado, redirecionando para', fallbackPath);
    return <Redirect to={fallbackPath} />;
  }

  // Se não há roles requeridas, permite acesso
  if (requiredRoles.length === 0) {
    // console.log('Nenhuma role requerida, permitindo acesso');
    return children;
  }

  // Verifica se o usuário tem pelo menos uma das roles requeridas
  const hasRequiredRole = requiredRoles.some(role => {
    // console.log(`Verificando role: ${role}`);
    
    if (role === "super") {
      const result = user?.super === true;
      // console.log(`Role super: ${result}`);
      return result;
    }
    if (role === "admin") {
      const result = user?.profile === "admin";
      // console.log(`Role admin: ${result}`);
      return result;
    }
    
    // Verifica roles personalizadas
    if (user?.roles && Array.isArray(user.roles)) {
      const result = user.roles.some(userRole => {
        // console.log(`Verificando userRole:`, userRole);
        // Verificar se userRole é um objeto com propriedade 'role' ou se é uma string
        if (typeof userRole === 'object' && userRole.role) {
          return userRole.role === role;
        } else if (typeof userRole === 'string') {
          return userRole === role;
        }
        return false;
      });
      // console.log(`Role personalizada ${role}: ${result}`, user.roles);
      return result;
    }
    
    // Fallback para verificação no profile
    const result = user?.profile === role;
    console.log(`Role fallback ${role}: ${result}`);
    return result;
  });

  // console.log('hasRequiredRole:', hasRequiredRole);

  // Se não tem a role necessária, redireciona
  if (!hasRequiredRole) {
    // console.log('Usuário não possui role necessária, redirecionando para', fallbackPath);
    return <Redirect to={fallbackPath} />;
  }

  // console.log('Usuário autorizado, renderizando conteúdo');
  return children;
};

export default ProtectedRoute;
